import { render, staticRenderFns } from "./LocaleEdit.vue?vue&type=template&id=97785d78&"
import script from "./LocaleEdit.vue?vue&type=script&lang=js&"
export * from "./LocaleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports